import type { Dayjs } from 'dayjs';

export const handleDate = (date: Dayjs | string) => {
  if (typeof date === 'string') {
    return date;
  } else if (typeof date === 'object') {
    return date.format('YYYY-MM-DD');
  } else {
    return '';
  }
};
